import { getPageTemplate, PAGE_TEMPLATE_IMPORT_MODES } from './pageTemplateRegistry';

const cloneWidget = (item, index) => {
  const component = String(item?.component || '').trim();
  if (!component) return null;
  const props = item?.props && typeof item.props === 'object' ? { ...item.props } : {};
  return {
    id: `page_template_${component}_${index + 1}`,
    component,
    version: Number(item?.version || 1),
    props,
  };
};

export const convertPageTemplateToLegacyWidgets = (templateId) => {
  const template = getPageTemplate(templateId);
  if (!template) throw new Error(`Unknown PromoShowcase page template: ${templateId}`);

  const widgets = (Array.isArray(template.widgets) ? template.widgets : [])
    .map(cloneWidget)
    .filter(Boolean);

  return {
    templateId: template.id,
    templateName: template.name,
    pageType: template.type,
    widgets,
  };
};

export const applyLegacyPageTemplateToLayout = ({ layout, slot, templateId, mode = PAGE_TEMPLATE_IMPORT_MODES.APPEND } = {}) => {
  const converted = convertPageTemplateToLegacyWidgets(templateId);
  const source = layout && typeof layout === 'object' ? layout : {};
  const slots = source.slots && typeof source.slots === 'object' ? source.slots : {};
  const current = Array.isArray(slots[slot]) ? slots[slot] : [];

  // Re-key imported widgets so the same page layout can safely be added more than once.
  const importNonce = Date.now().toString(36);
  const incoming = converted.widgets.map((item, index) => ({
    ...item,
    id: `psn_tpl_${importNonce}_${index + 1}`,
    props: {
      ...(item.props || {}),
      ...(item.component === 'form' && !item.props?.form_key
        ? { form_key: `psform_${importNonce}_${index + 1}` }
        : {}),
    },
  }));

  const nextWidgets = mode === PAGE_TEMPLATE_IMPORT_MODES.REPLACE
    ? incoming
    : [...current, ...incoming];

  return {
    layout: {
      ...source,
      version: source.version || 1,
      slots: { ...slots, [slot]: nextWidgets },
    },
    converted: { ...converted, widgets: incoming },
  };
};
